export class CheckoutCancel {
  constructor() {
    localStorage.removeItem('dataLayerData');
  }
}
